<template>

<span>
    <img src="../../assets/images/ALTA-Best-Practices.png" />
</span>
</template>


<style scoped>

</style>

<script setup></script>